import React from 'react';
import classNames from 'classnames';

export const AdvertiserRadio = ({
  checked = false,
  onChange = () => {},
  outerClassName = 'h-6 w-6 border-[2px] border-[#b1b1b1]',
  innerClassName = 'h-3 w-3 bg-[#0174d3]',
  checkedClassName = 'border-[2px] border-[#0174d3] bg-white',
  unCheckedClassName = 'border-[#b1b1b1]'
}) => {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onChange}
      onKeyDown={onChange}
      className={classNames(
        'flex items-center justify-center rounded-full border-solid cursor-pointer',
        outerClassName,
        checked ? checkedClassName : unCheckedClassName
      )}
    >
      {checked && (
        <div className={classNames('flex self-center rounded-full', innerClassName)} />
      )}
    </div>
  );
};
